import React, { useState, useEffect } from "react";
import { REZERVNA_SLIKA_URL } from "./dvoraneData";
import "../styles/dvoranaSlika.css";

function DvoranaSlika({ src, alt, className = "" }) {
  const [izvor, setIzvor] = useState(src || REZERVNA_SLIKA_URL);
  const [neuspjeh, setNeuspjeh] = useState(false);

  useEffect(() => {
    setIzvor(src || REZERVNA_SLIKA_URL);
    setNeuspjeh(false);
  }, [src]);

  const handleError = () => {
    if (izvor !== REZERVNA_SLIKA_URL) {
      setIzvor(REZERVNA_SLIKA_URL);
    } else {
      setNeuspjeh(true);
    }
  };

  if (neuspjeh) {
    return (
      <div className={`dvorana-placeholder ${className}`} role="img" aria-label={alt}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 3c3.5 2.5 5 6 5 9M12 3c-3.5 2.5-5 6-5 9M3.5 9c3 1.5 7 1.5 10 0M4 16c2.5-2 6-3 9.5-2.5M20 16c-2-3-5-5-8.5-5.5" />
        </svg>
      </div>
    );
  }

  const jeLogo = izvor === REZERVNA_SLIKA_URL;

  return (
    <img
      src={izvor}
      alt={alt}
      className={`${className} ${jeLogo ? "dvorana-slika-logo" : ""}`}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={handleError}
    />
  );
}

export default DvoranaSlika;
